{
  "verse": {
    "loading": "Загрузка аята...",
    "error": "Не удалось загрузить аят",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "arabicUnavailable": "(Арабский недоступен)",
    "english": "English",
    "arabic": "العربية",
    "swapLanguage_aria": "Сменить язык",
    "toggleLanguage_title": "Переключить English / Arabic",
    "reflect": "Размышление",
    "reflecting": "Думаю…",
    "reflect_aria": "Создать личное размышление, связывающее этот аят с вашим намерением",
    "insights": "Инсайты",
    "insights_aria": "Открыть AI-инсайты Корана",
    "share": "Поделиться",
    "share_aria": "Поделиться этим аятом как изображением",
    "share_title": "Поделиться этим аятом",
    "removeFromFavorites_aria": "Удалить из избранного",
    "saveToFavorites_aria": "Сохранить в избранное",
    "favoritesProLocked_aria": "Избранное — возможность Pro",
    "favoritesUpgrade_aria": "Перейдите на Pro, чтобы сохранять избранное",
    "signInToSave": "Войдите, чтобы сохранять в избранное.",
    "failedToUpdateFavorites": "Не удалось обновить избранное",
    "couldNotReflect": "Не удалось создать размышление",
    "shareCaption": "«{{text}}»\n— Surah {{surah}}, Ayah {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Изображение сохранено · аят скопирован",
    "imageSaved": "Изображение аята сохранено",
    "couldNotCreateImage": "Не удалось создать изображение"
  },
  "insights": {
    "panel_aria": "Панель инсайтов Корана",
    "title": "Инсайты",
    "reference": "Surah {{surah}}, Ayah {{ayah}}",
    "close_aria": "Закрыть панель инсайтов",
    "versePreview_aria": "Предпросмотр аята",
    "back_aria": "Назад",
    "tryAgain": "Повторить",
    "backTo_aria": "Назад к {{ref}}",
    "copyVerse_aria": "Копировать {{ref}}",
    "openingVerse": "Открываем аят…",
    "verseError": "Не удалось открыть аят."
  },
  "proGate": {
    "title": "AI-инсайты Корана — возможность Pro",
    "subtitleSafari": "Откройте глубокое контекстное понимание каждого аята с Rhemn Pro. Уже подписаны? Доступ откроется автоматически после входа.",
    "subtitle": "Откройте глубокое, контекстное понимание каждого аята.",
    "bulletAsk": "Задайте любой вопрос об аяте",
    "bulletTafsir": "Мгновенные сводки Tafsir на основе AI",
    "bulletRelated": "Откройте тематически связанные аяты",
    "upgrade": "Перейти на Pro"
  },
  "ask": {
    "heading": "Спросить",
    "suggestion1": "Каков более широкий контекст этого аята?",
    "suggestion2": "Как применить это в повседневной жизни?",
    "suggestion3": "Что говорят об этом классические учёные?",
    "placeholder": "Спросите что угодно об этом аяте…",
    "input_aria": "Задать вопрос об этом аяте",
    "submit_aria": "Отправить вопрос",
    "submit_title": "Отправить (⌘↵)",
    "submit_label": "Спросить",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Предлагаемые вопросы",
    "error": "Не удалось получить ответ.",
    "pending": "Размышляем над вашим вопросом…",
    "attribution": "Ответ, созданный AI · Не заменяет компетентное богословие"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Получите сводку Tafsir, созданную AI, для этого аята.",
    "generate": "Создать Tafsir",
    "commentary": "Толкование",
    "regenerate": "Создать заново",
    "regenerate_aria": "Создать tafsir заново",
    "attribution": "Сводка, созданная AI · Не заменяет компетентное богословие",
    "error": "Не удалось создать тафсир.",
    "pending": "Читаем толкование…"
  },
  "related": {
    "heading": "Связанные аяты",
    "copied": "Скопировано: {{ref}}",
    "failedToCopy": "Не удалось скопировать",
    "empty": "Связанные аяты не найдены.",
    "error": "Не удалось загрузить связанные аяты.",
    "pending": "Ищем связанные аяты…"
  },
  "favorites": {
    "panel_aria": "Избранные аяты",
    "title": "Избранные аяты",
    "proLocked": "Избранные аяты — возможность Pro.",
    "loading": "Загрузка…",
    "failedToLoad": "Не удалось загрузить избранное",
    "empty": "Избранного пока нет. Нажмите на сердечко рядом с аятом, чтобы сохранить его.",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "remove_aria": "Удалить из избранного",
    "failedToRemove": "Не удалось удалить"
  }
}
